import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

import { EnvironmentName } from '../../../core/enums/environment-name.enum';

import { AppService } from '../../../core/services/app.service';
import { EnvironmentService } from '../../../core/services/environment.service';

@Component({
  selector: 'app-browser-footer',
  templateUrl: './browser-footer.component.html',
  styleUrls: ['./browser-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrowserFooterComponent implements OnInit {
  public appVersion: string;
  public isProduction: boolean;
  public environmentName: EnvironmentName;

  constructor(private appService: AppService, private environmentService: EnvironmentService) {}

  ngOnInit() {
    this.appVersion = this.appService.getAppVersion();
    this.environmentName = this.environmentService.environmentName;
    this.isProduction = this.environmentName === EnvironmentName.Production;
  }
}
